import styled, { keyframes } from 'styled-components';
import { THUMBNAIL_HEIGHT } from '../consts';
import { ThumbnailDisplayInfo } from '../types';
import {
  calculateThumbnailDisplayRatio,
  calculateThumbnailFrameWidth,
  calculateThumbnailSpriteWidth,
} from '../utils';
import { ThumbnailFrame } from './ThumbnailFrame';

export type ThumbnailProps = ThumbnailDisplayInfo;

const styledAnimation = (imageWidth: number) => keyframes`
  from {
      background-position: 0 0;
    }
    to {
      background-position: -${imageWidth}px 0;
    }
`;

const ThumbnailEl = styled.div<{
  // $styledAnimation: (imageWidth: number) => Keyframes;
  $columns: number;
  $imageWidth: number;
}>`
  animation: ${(p: any) => p.$styledAnimation(p.$imageWidth)} 10s steps(${(p: any) => p.$columns})
    infinite;
`;

export function Thumbnail({
  url,
  offset,
  metadata,
  animated = false,
  targetHeight = THUMBNAIL_HEIGHT,
}: ThumbnailProps) {
  const displayRatio = calculateThumbnailDisplayRatio(metadata, targetHeight);
  const thumbWidth = calculateThumbnailFrameWidth(metadata, displayRatio);
  const thumbHeight = targetHeight;
  const thumbOffset = thumbWidth * offset;
  const imageWidth = calculateThumbnailSpriteWidth(metadata, displayRatio);

  const styles = {
    backgroundImage: `url(${url})`,
    width: `${thumbWidth}px`,
    height: `${thumbHeight}px`,
    backgroundSize: `${imageWidth}px auto`,
    backgroundPosition: `-${thumbOffset}px 0px`,
    backgroundRepeat: 'no-repeat',
  };

  const conditionThumbnail = animated ? (
    <ThumbnailEl
      $styledAnimation={styledAnimation}
      $columns={metadata.columns}
      $imageWidth={imageWidth}
      style={styles}
    />
  ) : (
    <div style={styles} />
  );

  return <ThumbnailFrame>{conditionThumbnail}</ThumbnailFrame>;
}
